import { deleteCookie } from '@parentScripts/components/cookie/deleteCookie';

export default async function initCommon(ensureModal) {
  deleteCookie('PREF');

  const $popupLinks = $('a[href^="#"]');

  if (!$popupLinks.length) return;

  const popupLinks = [];

  $popupLinks.each(function () {
    const href = $(this).attr('href');

    if (!href || href === '#') return;

    const popupId = href.substring(1);

    const modal = document.getElementById(
      `site-popup-${popupId}`
    );

    if (!modal) return;

    popupLinks.push(this);
  });

  if (!popupLinks.length) return;

  await ensureModal();

  $(popupLinks).on('click', function (event) {
    event.preventDefault();

    const popupId = $(this).attr('href').substring(1);

    const modal = document.getElementById(
      `site-popup-${popupId}`
    );

    if (!modal) return;

    const modalInstance =
      window.bootstrap.Modal.getOrCreateInstance(modal);

    modalInstance.show();
  });
}